//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { useContext } from "react";

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";
import Context from "context/context";

const KpiReport = () => {
  const { state, dispatch } = useContext(Context);
  const { handleResponse, handleError } = HandleApiResponse();

  async function welcomeEmailReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/kpi-reports/welcome-email-report`, obj);

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) {}
  }

  async function benefitCodeWeeklyReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/kpi-reports/benefit-code-weekly-report`, obj);

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) {}
  }

  async function fiscalMonthReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/kpi-reports/fiscal-month-report`, obj);

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) {}
  }

  async function consentedAndNonConsentedWeeklyReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/kpi-reports/consented-and-non-consented-weekly-report`, obj);
      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } 
    catch (err) {}
  }
     
  async function fscSummaryReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/kpi-reports/fsc-summary-report`, obj);
        // Progress bar
        let response = res.clone();
        progressStatus(response);
  
        return handleResponse(res);
    } 
    catch (err) {}
  }

  async function consentedAndNonConsentedMonthlyReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/kpi-reports/consented-and-non-consented-monthly-report`, obj);
      // Progress bar
      let response = res.clone();
      progressStatus(response);
      
      return handleResponse(res);
    } 
    catch (err) {}
  }

  async function fscConsentWeeklyReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/kpi-reports/fsc-consent-weekly-report`, obj);
      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } 
    catch (err) {}
  }

  async function marketoMailchimpReportAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/kpi-reports/marketo-or-mailchimp-report`, obj);

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) {}
  }

  async function progressStatus(response) {
    const reader = response.body.getReader();
    const contentLength = +response.headers.get("Content-Length"); // get total length
    let receivedLength = 0; // received that many bytes at the moment
    let previousValue;
    while (true) {
      const { done, value } = await reader.read();
      if (done) {
        break;
      }
      receivedLength += value.length;
      let progress = Math.round((receivedLength / contentLength) * 100);
      if (previousValue !== progress) {
        dispatch({ type: "SET_REPORT_RES_COUNT", payload: progress });
      }
      previousValue = progress;
    }
  }
  async function signatureStatementAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/kpi-reports/signature-statement-report`, obj);

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) {}
  }
  async function RollForwardAPI(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/kpi-reports/roll-forward`,
        obj
      );

      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getyearmonthAPI() {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/kpi-reports/monthyear`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err);
    }
  }

  async function monthlypointsexpiration(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/kpi-reports/monthly_points_expiration`, obj);
      // Progress bar
      let response = res.clone();
      progressStatus(response);

      return handleResponse(res);
    } 
    catch (err) {}
  }


  return {
    welcomeEmailReportAPI,
    benefitCodeWeeklyReportAPI,
    fiscalMonthReportAPI,
    consentedAndNonConsentedWeeklyReportAPI,
    fscSummaryReportAPI,
    consentedAndNonConsentedMonthlyReportAPI,
    fscConsentWeeklyReportAPI,
    marketoMailchimpReportAPI,
    signatureStatementAPI,
    RollForwardAPI,
    getyearmonthAPI,
    monthlypointsexpiration
  };
};
export default KpiReport;
